import React from 'react'
import VisDiv from './VisDiv'
import Link from 'next/link'
import {useStateContext} from '../../context/StateContext';


const SaveButton = ({saveFunction, saveDestination="", cancelFunction, cancelDestination=saveDestination, rules=[], saveRules=[true], cancelRules=[]}) => {
    const {LDB} = useStateContext();
  return (

        <VisDiv rules={rules} className='bottom-buttons'>
            <VisDiv rules ={saveRules} className='bottom-button'>
                <button type="button" style={{backgroundColor:"green"}} className="btn" onClick={saveFunction} >{LDB("misc", "save")}</button>
            </VisDiv>
            <VisDiv rules ={cancelRules} className='bottom-button'>
                <button type="button" style={{backgroundColor:"grey"}} className="btn" onClick={cancelFunction} >{LDB("misc", "cancel")}</button>
            </VisDiv>
        </VisDiv>  

  )
}

export default SaveButton
